module.exports = __webpack_public_path__ + "static/media/4.dfde4ca2.jpg";